import { useState } from "react";
import { FilterForm, type ExtraFilterItem } from "~/features/filter/filter.form";
import { useGetMeQuery } from "~/shared/api/auth/auth.api";

const DASHBOARD_FILTER_TABS = [
  { key: "all", label: "Все", count: 3 },
  { key: "so", label: "СО", count: 2 },
  { key: "tbo", label: "ТБО", count: 3 },
];

// INFO: make sure to include key for each filter item and make sure they are distinct
const DASHBOARD_EXTRA_FILTERS: ExtraFilterItem[] = [
  {
    key: "status",
    label: "Status",
    options: [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
      { value: "pending", label: "Pending" },
    ],
    selectedOptions: ["active", "pending"],
  },
  {
    key: "category",
    label: "Category",
    options: [
      { value: "electronics", label: "Electronics" },
      { value: "clothing", label: "Clothing" },
      { value: "books", label: "Books" },
    ],
    selectedOptions: ["books"],
  },
  {
    key: "price-range",
    label: "Price Range",
    options: [
      { value: "0-50", label: "$0 - $50" },
      { value: "50-100", label: "$50 - $100" },
      { value: "100+", label: "$100+" },
    ],
    selectedOptions: [],
  },
];

export const TempFilterPage = () => {
  const { data: userData } = useGetMeQuery({});
  const currentUser = userData?.user;
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [appliedTabKey, setAppliedTabKey] = useState<string>("all");
  const [appliedExtraFilters, setAppliedExtraFilters] =
    useState<ExtraFilterItem[]>(DASHBOARD_EXTRA_FILTERS);

  return (
    <div className="px-4">
      <div className="font-bold text-2xl">Welcome to Gov Filter Page {currentUser?.firstName}</div>
      <div className="mt-4">
        <button
          type="button"
          onClick={() => setIsFilterOpen(true)}
          className="rounded-lg bg-[#007AFF] px-4 py-2 text-sm font-medium text-white"
        >
          Open filters
        </button>
        <FilterForm
          open={isFilterOpen}
          onOpenChange={setIsFilterOpen}
          onApply={({ selectedTabKey, newSelected }) => {
            setAppliedTabKey(selectedTabKey);
            setAppliedExtraFilters(newSelected ?? []);
            setIsFilterOpen(false);
          }}
          filterTabs={DASHBOARD_FILTER_TABS}
          selectedTabKey={appliedTabKey}
          extraFilters={appliedExtraFilters}
        />
      </div>
    </div>
  );
};
